import ReactSwitch, { ReactSwitchProps } from "react-switch";
import styled, { css } from "styled-components";

import { theme } from "src/library/utils";

export enum SmartSwitchClass {
  ON = "active",
  OFF = "inactive"
}

export const SmartSwitch = styled(ReactSwitch)<ReactSwitchProps>`
  ${({ theme }) => css `
    &.${SmartSwitchClass.ON} {
    .react-switch-bg {
      background: transparent linear-gradient(90deg, ${theme.colors.smartLight} 0%, ${theme.colors.smartDark} 100%) 0% 0% no-repeat padding-box !important;
    }
    .react-switch-handle:before {
      background: url("/assets/bolt-smart-icon.svg") no-repeat center;
    }
  }
  &.${SmartSwitchClass.OFF} {
    .react-switch-bg {
      background: ${theme.colors.lightGrey} !important;
    }
    .react-switch-handle:before {
      background: url("/assets/bolt-light-grey.svg") no-repeat center;
    }
  }
  .react-switch-handle:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 17px;
    width: 17px;
    background-size: contain;
  }`}
`;

SmartSwitch.defaultProps = {
  offColor: theme.colors.lightGrey,
  onColor: theme.colors.smartLight,
  checkedIcon: false,
  uncheckedIcon: false
};
